import moment from 'moment-timezone';

/**
 * A function component that takes a date string and an optional timezone string
 * and returns the formatted date string.
 *
 * @param {Object} props
 * @param {String} props.date - date string
 * @param {String} props.tz - timezone string, defaults to 'America/New_York'
 * @returns {String} Formatted date string
 */
const DisplayTime = (props) => {
  const formattedDate = moment(props.date)
    .tz(props.tz || 'America/New_York')
    .format('ddd, MMM D, YYYY @ hh:mm A (z)');

  return formattedDate;
};

export default DisplayTime;
